import React, { useEffect, useRef } from 'react'
import './single-page.scss'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AllianceLogo from '../../../assets/images/alliance-logo.png'
import { IoChevronBack, IoSettings } from "react-icons/io5";
import { RiHome6Line } from "react-icons/ri";
import { LuLibrary } from 'react-icons/lu'
import { MdWindow } from 'react-icons/md'
import { YYYYMMDDFormat } from '../../../assets/javascript/date-helper'
import { GrBucket } from 'react-icons/gr'
import { TbCalendarMonth } from 'react-icons/tb'


function EnquiryPage({ pageHead, children }) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { internet } = useSelector((state) => state.systemInfo)
    const lastScrollTop = useRef(0);
    const navbarRef = useRef(null);
    // eslint-disable-next-line
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        const onScroll = () => {
            let currentScrollPos = window.pageYOffset || document.documentElement.scrollTop;

            if (currentScrollPos > lastScrollTop.current) {
                // Scroll Down, hide the navbar
                navbarRef.current.style.top = "-80px";
            } else {
                // Scroll Up, show the navbar
                navbarRef.current.style.top = "0";
            }

            lastScrollTop.current = currentScrollPos;
        };

        window.addEventListener("scroll", onScroll);

        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (

        <div className="single-page-body">
            <div className="single-page-header-div" ref={navbarRef}>
                <div className="border">
                    <div className="left" onClick={() => navigate(-1)}>
                        {(!searchParams.get('page') || searchParams.get('page') !== 'home') && <IoChevronBack />}
                        <img src={AllianceLogo} alt='logo' />
                        <div className='head-text'>
                            <h3>Alliance</h3>
                            <p>Sales Enquiry App</p>
                        </div>
                    </div>
                    <div className="right">
                        <div className="round-icon-button" title='App list' onClick={() => window.location.href = 'https://staff.alliancewatersolutions.com/?page=home'}>
                            <MdWindow />
                        </div>
                        <div className="round-icon-button" title='App list' onClick={() => navigate("/enquiry/settings")}>
                            <IoSettings />
                        </div>
                    </div>
                </div>
            </div>

            <div className="single-page-body-div">
                <div className="page-container">
                    <div className="page-title-div">
                        <div className="left">
                            <h3>{pageHead?.title}</h3>
                            <p>{pageHead?.desc}</p>
                        </div>
                        <div className="right">
                            {pageHead?.right}
                        </div>
                    </div>
                    <div className="page-content-div">
                        {children}
                    </div>
                </div>
            </div>

            <div className="single-page-menu-div">
                <div className="menu-div">
                    <div className={searchParams.get('page') === 'home' ? "item-div active-item" : "item-div"} onClick={() => navigate('/enquiry?page=home')}>
                        <RiHome6Line />
                        <p>Home</p>
                    </div>
                    <div className={searchParams.get('page') === 'bucket-list' ? "item-div active-item" : "item-div"} onClick={() => navigate(`/enquiry/bucket-list?page=bucket-list&date=${YYYYMMDDFormat(new Date())}`)}>
                        <GrBucket />
                        <p>Bucket List</p>
                    </div>
                    <div className={searchParams.get('page') === 'prospects' ? "item-div active-item" : "item-div"} onClick={() => navigate('/enquiry/prospects-queue?page=prospects')}>
                        <LuLibrary />
                        <p>Prospects</p>
                    </div>
                    <div className={searchParams.get('page') === 'calendar' ? "item-div active-item" : "item-div"}
                        onClick={() => navigate(`/enquiry/calendar/month/${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}?page=calendar`)}>
                        <TbCalendarMonth />
                        <p>Calendar</p>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default EnquiryPage